import { useDispatch } from 'react-redux';
import { createPayee } from 'lib/actions';
import { CustomerIOEvent, PayeeType } from 'lib/type/enums';
import { trackCustomerIOEvent } from 'utils/customerIO';

interface CreatePayeeProps {
    name: string;
    type: PayeeType;
    accountNumber: string;
    sortCode: string;
}

export const useCreatePayee = () => {
    const dispatch = useDispatch();
    const handleCreatePayee = async (data: CreatePayeeProps) => {
        const {
            name: payeeName,
            type,
            accountNumber: payeeAccountNo,
            sortCode,
        } = data;

        const result = await dispatch(
            createPayee({ payeeName, type, payeeAccountNo, sortCode }),
        );
        if (result.status === 200) {
            trackCustomerIOEvent(CustomerIOEvent.CREATE_PAYEE, {
                payeeName,
                type,
            });
        }
    };

    return {
        handleCreatePayee,
    };
};
